import React, { createContext, useContext, useState } from 'react';

interface OrderTypeContextProps {
    orderType: string;
    updateOrderType: (type: string) => void;
}

const OrderTypeContext = createContext<OrderTypeContextProps | undefined>(undefined);

export const OrderTypeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [orderType, setOrderType] = useState<string>(() => localStorage.getItem('orderType') || 'Takeaway');

    const updateOrderType = (type: string) => {
        setOrderType(type);
        localStorage.setItem('orderType', type);
    };

    return (
        <OrderTypeContext.Provider value={{ orderType, updateOrderType }}>
            {children}
        </OrderTypeContext.Provider>
    );
};

export const useOrderType = (): OrderTypeContextProps => {
    const context = useContext(OrderTypeContext);
    if (!context) {
        throw new Error('useOrderType must be used within an OrderTypeProvider');
    }
    return context;
};
